import { CLEAR_SEARCH_SUGGESTIONS } from '../constants/actionTypes';

const clearSearchSuggestions = () => ({
    type: CLEAR_SEARCH_SUGGESTIONS,
  });

export default clearSearchSuggestions;
